import { useAtom } from '@reatom/npm-react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import { SegmentControl } from '@blade/ui-kit'

import { showOnlyFavoritesAtom } from '../atoms'

import type { ClassNameProps } from '@root/shared/react'

type WalletsTab = 'all' | 'favorites'
type WalletsTabsProps = ClassNameProps

export const WalletsTabs: React.FC<WalletsTabsProps> = ({ className }) => {
  const { t } = useTranslation()
  const [onlyFavorites, setOnlyFavorites] = useAtom(showOnlyFavoritesAtom)

  return (
    <Root className={className}>
      <SegmentControl
        size="h36"
        value={(onlyFavorites ? 'favorites' : 'all') satisfies WalletsTab}
        onChange={(value) => setOnlyFavorites(value === 'favorites')}
      >
        <SegmentItem value={'all' satisfies WalletsTab}>
          {t('wallet.all_wallets')}
        </SegmentItem>
        <SegmentItem value={'favorites' satisfies WalletsTab}>
          {t('wallet.favorite')}
        </SegmentItem>
      </SegmentControl>
    </Root>
  )
}

const Root = styled.div`
  display: grid;
  justify-content: space-between;
`

const SegmentItem = styled(SegmentControl.Item)`
  text-transform: uppercase;
`
